export default __webpack_public_path__ + "static/media/numeros.bbf19a49.png";